// TODO: Fix eslint errors.
/* eslint-disable no-prototype-builtins */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-empty */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useIntl } from 'react-intl';

function GetRouteFromUrl() {
  // Load the routes for the specific country.
  const routesCore = require('../../config/core/client.routes.json');
  let routesOpCo = {};
  const supportedLanguages = [];
  let currentLanguage = process.env.REACT_APP_DEFAULT_LANGUAGE;
  try {
    routesOpCo = require(`../../config/${process.env.REACT_APP_COUNTRY}/client.routes.json`);
  } catch (e) {}
  const routes = {
    ...routesCore,
    ...routesOpCo,
  };
  for (const lang in routes) {
    supportedLanguages.push(lang);
  }
  const { locale } = useIntl();
  supportedLanguages.forEach((lang) => {
    if (locale.startsWith(lang)) {
      currentLanguage = lang;
    }
  });
  const currentUrl = useRouteMatch().path;
  const clientRoutes = routes[currentLanguage];
  for (const name in clientRoutes) {
    if (clientRoutes.hasOwnProperty(name)) {
      const route = clientRoutes[name];
      if (route.url === currentUrl) {
        return { name, ...route };
      }
    }
  }
  return null;
}

export default GetRouteFromUrl;
